





  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { IPaypalApproveData, IPaypalItem } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';

  @Component({ name: 'paypal-btn' })
  export default class BtnComponent extends Vue {
    @Prop() public items!: IPaypalItem[];

    public mounted() {
      if (this.$refs.paypalBtn !== undefined) {
        (window as any).paypal.Buttons({
          style: {
            color: 'silver'
          },
          fundingSource: (window as any).paypal.FUNDING.PAYPAL,
          createOrder: (data: any, actions: any) => {
            return actions.order.create({
              purchase_units: this.items
            });
          },
          onApprove: (data: IPaypalApproveData, actions: any) => {
            return AjaxHelper.post('/ShoppingCartPurchaseManagement', { OrderId: data.orderID, PayerId: data.payerID })
              .then(result => {
                console.log(result);
              });
          }
        }).render(this.$refs.paypalBtn);
      }
    }
  }
